import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import {
  ProductState,
  ProductStateStatus,
} from '@/shared/api/protocol-ts/api/billing_new/dto_product_new_pb';

import {
  packageStatusDefaultMessages,
  subscriptionStatusDefaultMessages,
} from '../../config/i18n';
import { ProductStatus } from '../../config/types';
import { getDisplayedServices } from '../../lib';
import { ServiceView } from '../ServiceView/ServiceView';

import styles from './InventoryItemView.module.scss';

type InventoryItemViewProps = {
  inventoryItem: ProductState;
  className?: string;
  testID?: string;
  // HACK: Used to display a scheduled subscription (Active + future Start) as
  // "Awaiting activation" without mutating the proto object or creating a
  // separate component. Remove once the backend sends the correct status.
  overrideStatus?: ProductStatus;
};

const statusStyles: Record<ProductStatus, string> = {
  [ProductStateStatus.ProductStateStatusActive]: styles.active,
  [ProductStateStatus.ProductStateStatusLifeTimeIsOver]: styles.expired,
  [ProductStateStatus.ProductStateStatusDeleted]: styles.blocked,
  [ProductStateStatus.ProductStateStatusAwaitingActivation]:
    styles.awaitingActivation,
};

export const InventoryItemView: FC<InventoryItemViewProps> = (props) => {
  const { className, testID, inventoryItem, overrideStatus } = props;

  const { formatMessage } = useIntl();

  const isSubscription = inventoryItem?.Model?.Kind.case === 'Subscription';

  const displayedServices = getDisplayedServices(inventoryItem?.Services);

  const status = (overrideStatus ?? inventoryItem?.Status) as ProductStatus;

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="inventory-item-view"
    >
      <div className={styles.title}>
        <div className={styles.statusBlock}>
          <h5 className={cn(styles.subscriptionName, 'h5')}>
            {inventoryItem?.Model?.Name}
          </h5>

          <div className={cn(styles.status, statusStyles[status])}>
            {isSubscription
              ? formatMessage(subscriptionStatusDefaultMessages[status])
              : formatMessage(packageStatusDefaultMessages[status])}
          </div>
        </div>
      </div>

      <div className={styles.services}>
        {displayedServices?.length > 0 &&
          displayedServices?.map((service) => (
            // TODO: [2/m] Think about key
            <ServiceView
              key={`${service.Group}-${service.Types}`}
              service={service}
            />
          ))}
      </div>
    </div>
  );
};
